import React, { useState } from "react";
import { CssBaseline, ThemeProvider, Grid, useMediaQuery } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Sidebar from "./scenes/global/Sidebar";
import Topbar from "./scenes/global/Topbar";
import Dashboard from "./scenes/dashboard/Dashboard";

const Admin = () => {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(false); // Sidebar is initially collapsed
  const isSmallScreen = useMediaQuery('(max-width:768px)'); // Detect small screens

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Grid container className="app" direction="row">
          {/* Sidebar */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              maxWidth: isSidebar ? "240px" : "60px", // Dynamic width based on sidebar state
              transition:  isSmallScreen ? 'none' : 'margin-left 0.3s ease', 
              width: isSidebar ? "60px" : "240px", // Ensure that the sidebar has the correct width
            }}
          >
            <Sidebar isCollapsed={isSidebar} setIsCollapsed={setIsSidebar} />
          </Grid>

          {/* Main content (Dashboard and Topbar) */}
          <Grid
            item
            xs
            style={{
              marginLeft: isSmallScreen ? '0px' : isSidebar ? '60px' : '240px',
              transition:  isSmallScreen ? 'none' : 'margin-left 0.3s ease', 
              padding: '20px',
              height: '180vh',
              overflowY: 'auto',
            }}
          >
            <Grid container direction="column">
              {/* Topbar */}
              <Grid item>
                <Topbar setIsSidebar={setIsSidebar} />
              </Grid>

              {/* Dashboard */}
              <Grid item>
                <Dashboard />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default Admin;
